import { createContext } from 'react';

export const CompanyContext = createContext({
  company: {},
});

export default CompanyContext;
